import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetRegionFailed, EGetRegionActionTypes } from './types';

export const getRegionFailed: () => TGetRegionFailed = actionGenerator<EGetRegionActionTypes.Failed>(
  EGetRegionActionTypes.Failed,
);
